module.exports = __webpack_public_path__ + "img/certificate-EC-outstanding.649ef6e3.jpg";